if (!customElements.get('featured-collection-carousel')) {
  class FeaturedCollectionCarousel extends HTMLElement {
    constructor() {
      super();

      this.swiperInit();
    }

    swiperInit() {
      const carousel = this.querySelector('[data-swiper]');

      if (!carousel) { return; }

      const prevButton = this.querySelector('[data-swiper-prev]');
      const nextButton = this.querySelector('[data-swiper-next]');
      const slidesPerView = parseInt(this.getAttribute('data-slides-per-view'), 10);

      const swiper = new window.Swiper(carousel, {
        spaceBetween: 16,
        slidesPerView: 'auto',
        draggable: true,
        loop: true,
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 24
          },
          1025: {
            slidesPerView: slidesPerView,
            spaceBetween: 24
          }
        },
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton
        }
      });

      return swiper;
    }
  }

  customElements.define('featured-collection-carousel', FeaturedCollectionCarousel);
}